module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_8023.c4838e6f.png";